import {Tooltip} from 'utils/bootstrap'

// Scoped to the icon-only single-value inner span. Match on
// data-bs-original-title, not title: Bootstrap 5 removes `title` once the
// tooltip shows, so a `[title]` selector stops matching and the tooltip never
// hides. useOptionFormatting renders both attributes.
const SELECTOR = '.rails_select__icon-only-single-value .rails_select--option[data-bs-original-title]'

let instance = null
let boundBody = null

export function hideActiveTooltip() {
  document.querySelectorAll(SELECTOR).forEach((element) => Tooltip.getInstance(element)?.hide())
}

export function initTooltipDelegation() {
  // Turbo Drive replaces <body> on each visit, taking the delegated listeners
  // and the container with it, so rebind once the body has changed.
  if (instance && boundBody === document.body)
    return

  disposeTooltipDelegation()

  boundBody = document.body
  instance = new Tooltip(document.body, {
    selector: SELECTOR,
    trigger: 'hover focus',
    container: '.app-layout-container',
    delay: {show: 100, hide: 50},
  })

  window.addEventListener('turbo:before-render', hideActiveTooltip)
  window.addEventListener('turbo:before-cache', hideActiveTooltip)
}

export function disposeTooltipDelegation() {
  if (!instance)
    return

  instance.dispose()
  instance = null
  boundBody = null
  window.removeEventListener('turbo:before-render', hideActiveTooltip)
  window.removeEventListener('turbo:before-cache', hideActiveTooltip)
}
